import { Autocomplete, TextField } from "@mui/material";
import { useInternalUsers } from "../../hooks/useEmail";

// Shared user-switcher dropdown for the Email Inbox and Email Campaigns pages — each staff
// member sends/receives via their own impersonated Gmail mailbox, so both pages are
// per-user with this as the way to switch whose index you're viewing. Same roster
// (GET /email-admin/users) on both pages. Autocomplete rather than a plain Select so the
// roster can be typed-to-filtered once it's more than a handful of names.
export default function EmailUserSwitcher({ selectedUserId, currentUserId, onChange }) {
  const { data } = useInternalUsers();
  const users = data?.users || [];

  const options = [
    { id: "all", label: "All users" },
    ...users.map((u) => ({
      id: u._id,
      label: String(u._id) === String(currentUserId) ? `${u.fullName || u.email} (you)` : u.fullName || u.email,
    })),
  ];

  const value = options.find((o) => o.id === (selectedUserId || "all")) || null;

  return (
    <Autocomplete
      disableClearable
      options={options}
      value={value}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      onChange={(_, newValue) => onChange(newValue ? newValue.id : "all")}
      ListboxProps={{ style: { maxHeight: 360, fontFamily: "Quicksand", fontSize: 14.5 } }}
      sx={{
        minWidth: 320,
        "& .MuiOutlinedInput-root": {
          bgcolor: "#fff",
          borderRadius: "8px",
          fontFamily: "Quicksand",
          fontSize: 14.5,
          py: "5px !important",
        },
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.id} style={{ fontFamily: "Quicksand", fontSize: 14.5, fontWeight: option.id === "all" ? 700 : 400, padding: "10px 14px" }}>
          {option.label}
        </li>
      )}
      renderInput={(params) => <TextField {...params} size="medium" placeholder="Search users…" />}
    />
  );
}
